export const easeOutExpo = [0.16, 1, 0.3, 1];

export const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.75, ease: easeOutExpo },
};

export const stagger = (i, base = 0.08) => ({
  ...fadeUp,
  transition: { ...fadeUp.transition, delay: i * base },
});
